import { render, staticRenderFns } from "./EventsDashboard.vue?vue&type=template&id=3e1e96a7&scoped=true"
import script from "./EventsDashboard.vue?vue&type=script&lang=js"
export * from "./EventsDashboard.vue?vue&type=script&lang=js"
import style0 from "./EventsDashboard.vue?vue&type=style&index=0&id=3e1e96a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1e96a7",
  null
  
)

export default component.exports